'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  cursor: ', ';\n  display: inline-flex;\n  width: ', ';\n  align-items: center;\n  justify-content: center;\n  min-height: ', ';\n  outline: 0;\n  border: none;\n  background: ', ';\n  color: ', ';\n  vertical-align: baseline;\n  padding: 0 ', ';\n  text-transform: none;\n  text-shadow: none;\n  font-weight: 500;\n  line-height: 1em;\n  font-style: normal;\n  font-size: ', ';\n  text-decoration: none;\n  border-radius: ', ';\n  user-select: none;\n  font-family: ', ';\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease,\n    box-shadow 0.1s ease, background 0.1s ease;\n  box-shadow: ', ';\n  border: ', ';\n  ', ';\n  ', ';\n'], ['\n  position: relative;\n  cursor: ', ';\n  display: inline-flex;\n  width: ', ';\n  align-items: center;\n  justify-content: center;\n  min-height: ', ';\n  outline: 0;\n  border: none;\n  background: ', ';\n  color: ', ';\n  vertical-align: baseline;\n  padding: 0 ', ';\n  text-transform: none;\n  text-shadow: none;\n  font-weight: 500;\n  line-height: 1em;\n  font-style: normal;\n  font-size: ', ';\n  text-decoration: none;\n  border-radius: ', ';\n  user-select: none;\n  font-family: ', ';\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease,\n    box-shadow 0.1s ease, background 0.1s ease;\n  box-shadow: ', ';\n  border: ', ';\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          min-height: ', ';\n        '], ['\n          min-height: ', ';\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n          &:hover {\n            background: ', ';\n          }\n          &:focus {\n            background: ', ';\n          }\n          &:active {\n            background: ', ';\n          }\n        '], ['\n          &:hover {\n            background: ', ';\n          }\n          &:focus {\n            background: ', ';\n          }\n          &:active {\n            background: ', ';\n          }\n        ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  transition: opacity 0.2s;\n  opacity: ', ';\n  display: flex;\n  align-items: center;\n'], ['\n  transition: opacity 0.2s;\n  opacity: ', ';\n  display: flex;\n  align-items: center;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n      margin-right: ', ';\n    '], ['\n      margin-right: ', ';\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transition: transform 0.2s, opacity 0.2s;\n  transform-origin: left top;\n  ', ';\n'], ['\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transition: transform 0.2s, opacity 0.2s;\n  transform-origin: left top;\n  ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n        opacity: 1;\n        transform: scale(1) translate(-50%, -50%);\n      '], ['\n        opacity: 1;\n        transform: scale(1) translate(-50%, -50%);\n      ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      opacity: 0;\n      transform: scale(0) translate(-50%, -50%);\n    '], ['\n      opacity: 0;\n      transform: scale(0) translate(-50%, -50%);\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Loader = require('../Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var customDarken = function customDarken(amount, color) {
  if (color === 'transparent') {
    return 'rgba(0, 0, 0, ' + amount + ')';
  }

  return (0, _polished.darken)(amount, color);
};

var Wrapper = _styledComponents2.default.button(_templateObject, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref2) {
  var block = _ref2.block;
  return block ? '100%' : 'auto';
}, function (theme) {
  return theme.small ? (0, _polished.rem)(40) : (0, _polished.rem)(50);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.buttonBackgroundColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.buttonTextColor;
}, (0, _polished.rem)(33), (0, _polished.rem)(14), function (_ref5) {
  var theme = _ref5.theme;
  return theme.largeBorderRadius;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.buttonShadow;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.buttonBorders;
}, function (_ref9) {
  var small = _ref9.small;
  return small ? (0, _styledComponents.css)(_templateObject2, (0, _polished.rem)(30)) : '';
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled ? '' : (0, _styledComponents.css)(_templateObject3, function (_ref11) {
    var theme = _ref11.theme;
    return customDarken(0.05, theme.buttonBackgroundColor);
  }, function (_ref12) {
    var theme = _ref12.theme;
    return customDarken(0.1, theme.buttonBackgroundColor);
  }, function (_ref13) {
    var theme = _ref13.theme;
    return customDarken(0.2, theme.buttonBackgroundColor);
  });
});

var Content = _styledComponents2.default.div(_templateObject4, function (_ref14) {
  var loading = _ref14.loading;
  return loading ? 0.25 : 1;
});

var StyledIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject5, function (_ref15) {
  var noMargin = _ref15.noMargin;
  return !noMargin && (0, _styledComponents.css)(_templateObject6, (0, _polished.rem)(9));
});
var StyledLoader = (0, _styledComponents2.default)(_Loader2.default)(_templateObject7, function (_ref16) {
  var loading = _ref16.loading;

  if (loading) {
    return (0, _styledComponents.css)(_templateObject8);
  }

  return (0, _styledComponents.css)(_templateObject9);
});

var Button = exports.Button = function Button(props) {
  var theme = props.theme,
      primary = props.primary,
      danger = props.danger,
      success = props.success,
      block = props.block,
      basic = props.basic,
      loading = props.loading,
      disabled = props.disabled,
      small = props.small,
      _onClick = props.onClick,
      size = props.size,
      noIconMargin = props.noIconMargin;
  var buttonTheme = {
    buttonBackgroundColor: 'transparent',
    buttonTextColor: theme.textColor,
    buttonShadow: theme.shadow,
    buttonBorders: '',
    buttonSmall: small
  }; // basic states

  if (primary) {
    if (basic) {
      buttonTheme = _extends({}, buttonTheme, {
        buttonTextColor: theme.color.primary,
        buttonShadow: '',
        buttonBorders: '2px solid ' + theme.color.primary
      });
    } else {
      buttonTheme = _extends({}, buttonTheme, {
        buttonBackgroundColor: theme.color.primary,
        buttonTextColor: '#fff'
      });
    }
  } else if (danger) {
    if (basic) {
      buttonTheme = _extends({}, buttonTheme, {
        buttonTextColor: theme.color.danger,
        buttonShadow: '',
        buttonBorders: '2px solid ' + theme.color.danger
      });
    } else {
      buttonTheme = _extends({}, buttonTheme, {
        buttonBackgroundColor: theme.color.danger,
        buttonTextColor: '#fff'
      });
    }
  } else if (success) {
    if (basic) {
      buttonTheme = _extends({}, buttonTheme, {
        buttonTextColor: theme.color.success
      });
    } else {
      buttonTheme = _extends({}, buttonTheme, {
        buttonBackgroundColor: theme.color.success,
        buttonTextColor: '#fff'
      });
    }
  }

  if (disabled) {
    if (basic) {
      buttonTheme = _extends({}, buttonTheme, {
        buttonTextColor: theme.inactiveColor,
        buttonShadow: '',
        buttonBorders: '2px solid ' + theme.inactiveColor
      });
    } else {
      buttonTheme = _extends({}, buttonTheme, {
        buttonBackgroundColor: theme.inactiveColor,
        buttonTextColor: '#fff',
        buttonShadow: ''
      });
    }
  }

  return _react2.default.createElement(_styledComponents.ThemeProvider, {
    theme: buttonTheme
  }, _react2.default.createElement(Wrapper, {
    className: props.className,
    block: block,
    disabled: disabled,
    small: small,
    onClick: function onClick(e) {
      if (!disabled) {
        _onClick(e);
      }
    }
  }, _react2.default.createElement(Content, {
    loading: loading
  }, props.icon && _react2.default.createElement(StyledIcon, {
    width: 24,
    height: 24,
    name: props.icon,
    color: buttonTheme.buttonTextColor,
    noMargin: noIconMargin
  }), props.children), _react2.default.createElement(StyledLoader, {
    size: size,
    loading: loading,
    color: buttonTheme.buttonTextColor
  })));
};

Button.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  primary: _propTypes2.default.bool,
  danger: _propTypes2.default.bool,
  success: _propTypes2.default.bool,
  block: _propTypes2.default.bool,
  basic: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  theme: _propTypes2.default.shape({
    textColor: _propTypes2.default.string.isRequired
  }).isRequired,
  icon: _propTypes2.default.string,
  small: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  size: _propTypes2.default.string,
  noIconMargin: _propTypes2.default.bool
};
Button.defaultProps = {
  className: '',
  children: null,
  primary: false,
  danger: false,
  success: false,
  block: false,
  basic: false,
  loading: false,
  disabled: false,
  icon: null,
  small: false,
  size: 'l',
  noIconMargin: false,
  onClick: function onClick() {}
};
exports.default = (0, _styledComponents.withTheme)(Button);
Button.__docgenInfo = [{
  'description': '',
  'displayName': 'Button',
  'methods': [],
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'children': {
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'primary': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'danger': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'success': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'block': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'basic': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'loading': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'disabled': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'theme': {
      'type': {
        'name': 'shape',
        'value': {
          'textColor': {
            'name': 'string',
            'required': true
          }
        }
      },
      'required': true,
      'description': ''
    },
    'icon': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'small': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'onClick': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'size': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'l\'',
        'computed': false
      }
    },
    'noIconMargin': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Button/index.js'] = {
    name: 'Button',
    docgenInfo: Button.__docgenInfo,
    path: 'src/Button/index.js'
  };
}